import { BLOCK_TYPES } from '../blocks/types.js';
import { SERVICE_CATALOG, servicePath } from '../../navigation/serviceCatalog.js';

// Service Content — Hotel Transfer (golden pattern: PR #250-#254). Authored FRENCH content from
// existing Content-Platform blocks. This is strictly a TRANSPORT page: a private chauffeur driving the
// client TO and FROM their hotel. Facts used are owner-ratified / inherent to the service (hotel
// transfers, hotel pickup, hotel drop-off) + the general verified set (chauffeur privé premium,
// Nantes/Loire-Atlantique, ponctualité, discrétion, confort, online booking, price-before-booking,
// 24/7, SAB area). NO hotel-specific marketing copy exists in the locales, so nothing hotel-specific
// is invented beyond pickup/drop-off transport.
// FORBIDDEN (NOT present): concierge, réception, hotel partnerships/preferred hotels/network,
// voiturier, bagagiste, luggage-handling, VIP, dedicated/guaranteed chauffeur, vehicle brand/model,
// exact prices, reviews/ratings/awards/certifications. Vehicles BRAND-NEUTRAL. CTA = book OR contact
// (/reserver + /contact) — no /entreprises link (keeps the page free of any partnership framing).
// Mesh derived from the ratified catalogue.

const SLUG = 'hotel-transfer';
const siblings = SERVICE_CATALOG
  .filter((s) => s.slug !== SLUG)
  .map((s) => ({ label: s.name, to: servicePath(s.slug) }));

export default {
  blocks: [
    {
      type: BLOCK_TYPES.HERO,
      kicker: 'Chauffeur privé premium',
      title: 'Transfert hôtel à Nantes',
      lead:
        'Un chauffeur privé pour vos trajets vers et depuis votre hôtel à Nantes et en Loire-Atlantique — ponctuel, discret et au prix connu à l’avance.',
    },
    {
      type: BLOCK_TYPES.INTRO,
      text:
        'Black Matte assure vos transferts vers et depuis votre hôtel à Nantes et en Loire-Atlantique, avec des véhicules haut de gamme et un service ponctuel et discret, réservable en ligne 24h/24, 7j/7.',
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Pourquoi réserver votre transfert hôtel avec Black Matte',
      body: [
        'À votre arrivée comme à votre départ, un chauffeur privé vous conduit directement vers ou depuis votre hôtel, sans gérer le stationnement ni l’itinéraire — idéal après un vol, un train ou une longue journée.',
        'Vous voyagez à bord d’un véhicule haut de gamme, confortable et soigné, conduit par un chauffeur privé professionnel et discret. Le prix vous est communiqué avant la réservation, en toute transparence.',
      ],
    },
    {
      type: BLOCK_TYPES.FEATURE_GRID,
      heading: 'Un transfert hôtel sans souci',
      items: [
        { title: 'Ponctualité', text: 'Une prise en charge à l’heure, à votre hôtel comme à votre adresse de départ.' },
        { title: 'Discrétion', text: 'Un service professionnel et confidentiel, à chacun de vos trajets.' },
        { title: 'Confort', text: 'Un véhicule haut de gamme, spacieux et soigné, pour un trajet reposant.' },
        { title: 'Réservation simple', text: 'Réservez en ligne en quelques minutes, avec un prix connu à l’avance.' },
      ],
    },
    {
      type: BLOCK_TYPES.STEPS,
      heading: 'Comment réserver votre transfert hôtel',
      steps: [
        { title: 'Indiquez votre trajet', text: 'Renseignez votre hôtel, votre point de départ ou d’arrivée, la date et l’heure.' },
        { title: 'Obtenez votre tarif', text: 'Votre prix est calculé et communiqué avant de confirmer la réservation.' },
        { title: 'Confirmez en ligne', text: 'Validez votre réservation en quelques minutes, directement en ligne.' },
        { title: 'Votre chauffeur vous accueille', text: 'Votre chauffeur vous prend en charge à votre hôtel ou vous y dépose, à l’heure convenue.' },
      ],
    },
    {
      type: BLOCK_TYPES.RICH_TEXT,
      heading: 'Vos transferts hôtel à Nantes et en Loire-Atlantique',
      body: [
        'Transfert depuis l’aéroport de Nantes Atlantique ou la gare vers votre hôtel, trajet d’un hôtel vers un rendez-vous ou un événement, ou départ de votre hôtel : Black Matte assure les déplacements liés à votre séjour.',
        'Notre service couvre Nantes et sa région, ainsi qu’Angers, Rennes et La Roche-sur-Yon, 24h/24 et 7j/7, avec des chauffeurs privés professionnels et discrets.',
      ],
    },
    {
      type: BLOCK_TYPES.CTA,
      heading: 'Réservez votre transfert hôtel',
      text: 'Réservez votre chauffeur privé pour votre transfert hôtel, ou contactez-nous pour toute demande particulière.',
      actions: [
        { label: 'Réserver', to: '/reserver' },
        { label: 'Nous contacter', to: '/contact' },
      ],
    },
    {
      type: BLOCK_TYPES.RELATED_CONTENT,
      heading: 'Autres prestations',
      links: siblings,
    },
  ],
};
